<template>
  <div class="margin-left" style="position: relative;">
    <p class="flex align-center text-999 text-sm pointer back" @click="back()">
    	<i class="el-icon-back"></i>
    	<span style="margin-left: 5px;">返回</span>
    </p>
    <div class="flex-col flex-auto section_4">
      <div class="flex-col space-y-28">
        <div class="flex-row group_8 space-x-45">
          <span class="self-start font_6 text_16">封面</span>

          <div>
            <!-- <img class="image_7"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/646d6b8c74467400114fcca6/16849084943436628515.png" />
            <span class="font_7 text_18">点击上传封面</span> -->

            <el-upload class=" avatar-uploader flexCenter" action="https://manage.ciiply.com/api/pc/user/upFile"
              :show-file-list="false" :on-success="coverSuccess">
              <img v-if="setData.logo" :src="setData.logo" class="cover">
              <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <div v-else class="upload flex flex-direction align-center justify-center bg-white dvly">
                <img class="uploadimg" src="../../../assets/img/upload.png">
                <div class="text-sm text-999 upLoadText">点击上传封面</div>
              </div>
            </el-upload>

          </div>

        </div>
        <div class="flex-row">
          <div class="flex-row items-center space-x-45">
            <span class="font_6">起订量</span>
            <input class="flex-row items-center shrink-0 section_6 space-x-11" placeholder="请输入"
              v-model="setData.start_name">

          </div>
          <div class="flex-row items-center group_10 space-x-17">
            <span class="font_6 text_20">件装数量</span>
            <input class="flex-row items-center shrink-0 section_6 space-x-11" placeholder="请输入"
              v-model="setData.jian_num">
          </div>
          <div class="flex-row items-center group_11 space-x-17">
            <span class="font_6 text_23">单价规格</span>
            <input class="flex-row items-center shrink-0 section_6 space-x-11" placeholder="请输入" v-model="setData.spec">
          </div>
        </div>
        <div class="flex-row justify-center relative">
          <div class="flex-row items-center space-x-28 pos_3">
            <span class="font_6">设置单价</span>

            <div style="position: relative;">
              <input class="flex-row items-center shrink-0 section_6 space-x-11 sym" placeholder="请输入"
                v-model="setData.price">
              <span class="font_6 text_28">元</span>
            </div>
          </div>

          <div class="flex-row items-center">
            <span class="font_6 text_26">出货天数</span>
            <div style="position: relative;">
              <input class="flex-row items-center shrink-0 section_6 space-x-11 sym" placeholder="请输入"
                v-model="setData.day">
              <span class="font_6 text_28">天</span>
            </div>
          </div>
        </div>
        <div class="flex-row items-center group_13 space-x-46">
          <span class="font_6 text_32">标题</span>
          <input type="text" class="flex-col justify-start items-start flex-auto text-wrapper_7" placeholder="请输入产品名"
            v-model="setData.name">
        </div>
        <!-- 分类筛选 -->
        <div>

          <div class="flex-row items-center group_13 space-x-46">
            <span class="font_6 text_32">分类</span>
            <el-cascader
             :options="options"
             :show-all-levels="false"
             @change="changeFun"
               :value="setData.cate_id"></el-cascader>
          </div>

        </div>

        <div class="flex-row items-center group_6 space-x-45">
          <div class="flex-col items-center shrink-0 space-y-228">
            <span class="font_6">介绍</span>
          </div>
          <div class="flex-col flex-auto space-y-18">
            <textarea class="flex-col justify-start items-start text-wrapper_8" placeholder="请输入具体产品的相关介绍描述"
              v-model="setData.des"></textarea>
            <div class="">

            </div>

            <!-- <el-upload class="flex-col self-start section_9 space-y-57"
              action="https://manage.ciiply.com/api/pc/user/upFile" :show-file-list="false"
              :on-success="handleAvatarSuccess">
              <img v-if="setData.images" :src="setData.images" class="avatar">

              <div class="uploadCenter flexCenter" v-else>
                <div class="flex-col items-center space-y-15">
                  <span class="text_35">+</span>
                  <span class="font_7">上传</span>
                  <span class="self-center font_3 text_36">商品图片尺寸建议628*470</span>
                </div>

              </div>

            </el-upload> -->




          </div>
        </div>

        <div class="imgBox">
          <span class="font_6 imgBoxTitle">图片</span>
          <div class="imgBoxContent">
            <el-upload :file-list="add_ObjDetails" style="display: inline-block; margin-left: 30px;display: flex;
  flex-wrap: wrap;
  justify-content: start;" :on-success="handleAvatarSuccess" :limit='4' :on-exceed="handleExceed"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG" action="https://manage.ciiply.com/api/pc/user/upFile"
              list-type="picture-card" :on-remove="handleRemove">
              <!-- <i class="el-icon-plus"></i> -->
              <div class="uploadCenter flexCenter" v-if="!dialogVisible">
                <div class="flex-col items-center space-y-15">
                  <span class="text_35">+</span>
                  <span class="font_7">上传</span>
                  <span class="self-center font_3 text_36">商品图片尺寸建议628*470</span>
                </div>

              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">

              <!-- <img width="100%" :src="dialogImageUrl" alt=""> -->
            </el-dialog>
          </div>

        </div>

      </div>
      <div class="flex-row justify-center group_15 space-x-12">
        <div class="input" @click="keyChange">
          <div class="keyBox flexCenter">
            <div class="keyCenter" v-show="isChecked"></div>
          </div>
        </div>

        <div class="group_16">
          <span class="font_5">发布产品即表示遵守</span>
          <a class="font_5 text_37" @click="toKey">《蓝友网信息发布规则》</a>
          <span class="font_5">
            ，如果您违反规则可能导致您的账号异常
            <br />
          </span>
        </div>
      </div>

      <div class="flex-col items-center group_17 space-y-28">
        <div class="flex-col justify-start items-center text-wrapper_10" @click="submit"><span
            class="text_38">提交发布</span></div>
        <span class="font_3">发布成功后，平台会在1个工作日内审核完成即可显示</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
    mapState
  } from 'vuex';
  export default {
    components: {},
    data() {
      return {
        optionsData:'',//当前二级分类选中value
        add_ObjDetails: [],
        dialogImageUrl: '',
        dialogVisible: false,
        isChecked: false, //是否同意协议
        setData: {
          cate_id: 4, //当前分类id
          images: '', //图片
          logo: '', //封面
          start_name: '', //起购数量
          jian_num: '', //件装数量
          spec: '', //单位规格
          price: '', //单价数量
          day: '', //计件天数
          name: '', //产品名
          des: '', //简介
        },
        changeImg: [], //中转图片
        // 分类选项
        options: [],
        isOk:false//当前是否请求到分类数据

      };
    },
    computed: {
      ...mapState(['setSupplyData'])
    },
    created() {
      this.setData = this.setSupplyData;
      let arr = [];
      let change = [];
      if(this.setData.images){
        change = this.setData.images.split('|');
        for(let i in change){
          arr.push({
            url: change[i],
          });
        }

        this.add_ObjDetails = arr;
      }

    },
    mounted() {
      this.getOneCate();
    },
    beforeDestroy: function() {
      this.$store.commit('setSupplyAdd', {})
    },
    methods: {
      changeFun(e){
        // 当前选中分类
        if(e[1]){
          this.setData.cate_id = e[1];
        }
      },
      // 跳转蓝友发布规则
      toKey(){
        this.$confirm('确定要离开发布页面吗, 您的编辑内容将会丢失', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

           this.$router.push({
             name:'key'
           })

          })


      },
      // 删除图片
      handleRemove(file, fileList) {
        // 点击删除图片，获取图片文件file,
        // 筛选出图片文件file.url和图片数组的url一致的数据
        // 删除掉这个数据
        this.add_ObjDetails.filter((item, index) => {
          if (item.url == file.url) {
            this.add_ObjDetails.splice(index, 1);
          }
        });
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 4 张图片，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length} 个文件`);
      },
      // 上传图片显示
      handleAvatarSuccess(file, fileList) {
        // this.$set(this.setData, 'images', file.data.url);
        // this.changeImg.push(file.data.url);
        // console.log(this.fileList)
        let imgObj = {
          url: file.data.url,
        };
        this.add_ObjDetails.push(imgObj);
      },
      // 一级分类获取
      getOneCate() {
        this.ajax('get', '/api/pc/goods/getAllGoodsCate', {},  async res => {
          for (let i in res.data.cate) {
            res.data.cate[i].label = res.data.cate[i].cate_name;
            res.data.cate[i].value = res.data.cate[i].id;

            // 在循环中进行请求对应一级次数的数据
            let end = await this.ajax('get', '/api/pc/goods/getAllGoodsCate', {
              pid: res.data.cate[i].id
            }, end => {
              for (let j in end.data.ercate) {
                // 对二次分类数据进行处理
                end.data.ercate[j].label = end.data.ercate[j].cate_name;
                end.data.ercate[j].value = end.data.ercate[j].id;
                // 插入数据
                res.data.cate[i].children = end.data.ercate;
                // this.options = res.data.cate;
                this.isOk = true;
              }

              // console.log(this.options,'??')
              // 拿到数据以后再启动定时器
              if(this.isOk){
                setTimeout(()=>{
                  this.options = res.data.cate;
                  console.log(this.options,'?')
                },3000)
              }



            })

          }
        })
        /* this.ajax('get', '/api/pc/goods/getAllGoodsCate', {}, res => {
          for (let i in res.data.cate) {
            res.data.cate[i].label = res.data.cate[i].cate_name;
            res.data.cate[i].value = res.data.cate[i].id;
            // 在循环中进行请求对应一级次数的数据
            this.ajax('get', '/api/pc/goods/getAllGoodsCate', {
              pid: res.data.cate[i].id
            }, end => {
              for (let j in end.data.ercate) {
                // 对二次分类数据进行处理
                end.data.ercate[j].label = end.data.ercate[j].cate_name;
                end.data.ercate[j].value = end.data.ercate[j].id;
              }
              // 插入数据
              res.data.cate[i].children = end.data.ercate;
              this.options = res.data.cate;
              console.log(this.options,'options')
            })

          }
        }) */
      },

      // 上传封面显示
      coverSuccess(file) {
        this.$set(this.setData, 'logo', file.data.url);
        console.log(this.setData)
      },
      // 进行提交
      submit() {
        // 处理图片数据
        let arr = [];
        for (let i in this.add_ObjDetails) {
          arr.push(this.add_ObjDetails[i].url)
        }
        this.setData.images = arr.join('|');
         console.log(this.setData,'当前提交数据')
        // 判空
        if (this.setData.logo == ''||!this.setData.logo) {
          this.$message.error('请上传封面图');
          return false;
        } else if (this.setData.spec == ''||!this.setData.spec) {
          this.$message.error('请输入单位规格');
          return false;
        } else if (this.setData.price == ''||!this.setData.price) {
          this.$message.error('请输入单价');
          return false;
        } else if (this.setData.name == ''||!this.setData.name) {
          this.$message.error('请输入产品名称');
          return false;
        } else if (this.setData.cate_id == ''||!this.setData.cate_id) {
          this.$message.error('请选择分类');
          return false;
        } else if (this.setData.des == ''||!this.setData.des) {
          this.$message.error('请输入简介');
          return false;
        }else if (this.setData.images == ''||!this.setData.images) {
          this.$message.error('请上传产品图片');
          return false;
        }else if (this.isChecked == '') {
          this.$message.error('请勾选协议');
          return false;
        }


        // 修改联系人
        this.ajax('post', '/api/pc/goods/saveGoods', this.setData, res => {
          if (res.data.code == 200) {
            this.$message.success('发布成功');

            // 归零
            for (let key in this.setData) {
              this.setData[key] = '';
            }

            this.isChecked = false;

            this.add_ObjDetails = [];

            this.optionsData = ''
          }else{
            this.$message.error(res.msg);
          }


        })
      },
      keyChange(e) {
        if (this.isChecked) {
          this.isChecked = false;
        } else {
          this.isChecked = true;
        }
      },
      // 退回上一步
      back(){
        // 改变vuex
        this.$store.commit('isBackFun',true)
        // 跳转产品编辑
        this.$emit('gettype', {
          type: 'adminsupply',
          typeone: ''
        });
        // 改变侧边栏颜色
        this.$emit('leftFun', 5);

      }

    },
  };
</script>

<style scoped lang="css">
  @import url("sendGoods.css");
</style>



// WEBPACK FOOTER //
// src/components/my/supply/sendGoods.vue